<template>
  <div class="form-entrar">
    <div id="butom">
      <router-link :to="{ name: 'autenticacao-gex' }">Voltar ao Login</router-link>
    </div>

    <h3>Alteração de E-mail</h3>

    <!-- Estado 1: Token ausente na URL -->
    <template v-if="!token">
      <div class="msg-erro" role="alert">
        O link de alteração de e-mail é inválido ou não contém o código de confirmação.
      </div>
      <router-link to="/login" class="submit-login link-btn">
        Ir para a página de Login
      </router-link>
    </template>

    <!-- Estado 2: Concluído com Sucesso -->
    <template v-else-if="sucesso">
      <div class="msg-sucesso" role="status" aria-live="polite">
        <p class="sucesso-titulo">✅ E-mail alterado com sucesso!</p>
        <p class="sucesso-desc">
          Seu e-mail foi atualizado na base de dados. Por favor, faça login utilizando suas novas credenciais.
        </p>
      </div>

      <router-link to="/login/autenticacao-gex" class="submit-login link-btn">
        Acessar com o Novo E-mail
      </router-link>
    </template>

    <!-- Estado 3: Pronto para confirmação -->
    <template v-else>
      <h4>Clique no botão abaixo para concluir a troca de e-mail da sua conta no GEX.</h4>

      <div v-if="mensagemErro" class="msg-erro" role="alert" aria-live="assertive">
        {{ mensagemErro }}
      </div>

      <button
        class="submit-login"
        type="button"
        :disabled="isLoading"
        @click="enviar"
      >
        <span
          v-if="isLoading"
          class="spinner"
          aria-hidden="true"
        ></span>
        {{ isLoading ? "Confirmando alteração..." : "Confirmar Alteração" }}
      </button>
    </template>
  </div>
</template>

<script>
import router from "@/router";
import usuariosService from "@/service/usuariosService";

export default {
  data() {
    return {
      token: null,
      isLoading: false,
      sucesso: false,
      mensagemErro: "",
    };
  },

  mounted() {
    this.token =
      this.$route?.query?.token ||
      new URLSearchParams(window.location.search).get("token") ||
      null;
  },

  methods: {
    async enviar() {
      if (!this.token) {
        this.mensagemErro = "Código de confirmação ausente.";
        return;
      }

      this.isLoading = true;
      this.mensagemErro = "";

      try {
        const response = await usuariosService.confirmarAlteracaoEmail(this.token);

        if (response && (response.status === 200 || response.status === 204)) {
          this.sucesso = true;
          // Limpa tokens antigos para evitar conflitos de subject no JWT
          window.localStorage.removeItem("auth_token");
          window.localStorage.removeItem("refresh_token");
          window.localStorage.removeItem("user");
        } else {
          this.mensagemErro = "Não foi possível concluir a alteração. O link pode ter expirado.";
        }
      } catch (error) {
        console.error("Erro ao confirmar alteração de e-mail:", error);
        const backendMsg =
          error?.response?.data?.message ||
          error?.response?.data?.details ||
          error?.data?.message ||
          "Não foi possível confirmar a alteração. O link pode ter expirado ou já ter sido utilizado.";
        this.mensagemErro = backendMsg;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.form-entrar {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  background: var(--branco);
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px hsla(0, 0%, 0%, 0.15);
  padding: 2.5rem 2rem;
  width: 100%;
  max-width: 420px;
  animation: fadeIn 0.4s ease-in-out;
}

.form-entrar h3 {
  margin: 0;
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--roxo-medio);
  text-align: center;
}

.form-entrar > div:first-child a {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.6rem;
  background: var(--roxo-medio);
  border: none;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--branco);
  transition: all 0.3s ease;
  text-decoration: none;
}

.form-entrar > div:first-child a::before {
  content: "←";
  font-size: 0.9rem;
}

.form-entrar > div:first-child a:hover {
  background: var(--roxo-primario);
}

h4 {
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--cinza-escuro, #333);
  text-align: center;
  line-height: 1.5;
  margin: 0;
}

.submit-login {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0.85rem 1.2rem;
  background: var(--roxo-primario);
  color: var(--branco);
  border: none;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  text-decoration: none;
  text-align: center;
}

.submit-login:hover:not(:disabled) {
  background: var(--roxo-medio);
}

.submit-login:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.link-btn {
  width: 100%;
  box-sizing: border-box;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid var(--branco);
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.msg-sucesso {
  font-size: 0.9rem;
  color: #15803d;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  padding: 1rem 1.2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.sucesso-titulo {
  font-weight: 700;
  font-size: 1rem;
  margin: 0;
}

.sucesso-desc {
  margin: 0;
  font-size: 0.88rem;
  color: #166534;
  line-height: 1.4;
}

.msg-erro {
  font-size: 0.88rem;
  color: #b91c1c;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 0.8rem 1rem;
  text-align: center;
  line-height: 1.4;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
